import { createStore } from 'vuex'

const store = createStore({
    state:{ 
		LANDUI:'true',
		foldStatus:'false',
		menuStatus1:'true',
		menuStatus2:'true',
		menuStatus3:'true',
		sidebarStatus:'false',
		userName:'',
		loginFlag:false,
    },
    mutations:{
		setLogin (state, value) {
			state.loginFlag = value;
		},
		setUserName (state, value) {
			state.userName = value;
		},
		setUI (state, value) {
			state.LANDUI = value
		},
		setfoldStatus (state, value) {
			state.foldStatus = value
		},
		setmenuStatus1 (state, value) {
			state.menuStatus1 = value;
		},
		setmenuStatus2 (state, value) {
			state.menuStatus2 = value;
		},
		setmenuStatus3 (state, value) {
			state.menuStatus3 = value;
		},
		setsideStatus (state, value) {
			state.sidebarStatus = value
		}
	}
})

export default store